import React from "react";
import { Dialog, DialogContent } from "@/components/ui/dialog";
import { BUTTONS, HEADINGS } from "@/utils/constants/appConstants/commonConstants";
import { TAG_TEXT } from "@/utils/constants/messages";
import { useAppDispatch } from "@/state/hooks";
import { deleteTagThunk } from "@/state/tags/thunks";
import { errorToasterMessage } from "@/utils/functions/toaster";
import { ButtonLoadingContent, loadingButtonClass } from "@/components/buttons/ButtonLoadingContent";
import { Button } from "@/components/ui/button";

const DeleteTagModal = (props: { show: boolean; onHide?: () => void; selectedTag?: { id?: string | number; name?: string } }) => {
    const dispatch = useAppDispatch();
    const [isLoading, setIsLoading] = React.useState(false);

    const handleHideModal = () => {
        props.onHide?.();
    };

    const handleDeleteTag = async () => {
        if (!props.selectedTag?.id) {
            return;
        }
        setIsLoading(true);
        try {
            await dispatch(deleteTagThunk(props.selectedTag.id)).unwrap();
            setIsLoading(false);
            handleHideModal();
        } catch (err: any) {
            setIsLoading(false);
            errorToasterMessage(err?.message || TAG_TEXT.FAILED_DELETE_TAG);
        }
    };

    return (
        <Dialog open={props.show} onOpenChange={(open) => { if (!open) handleHideModal(); }}>
            <DialogContent className="gs-tag-dialog">
                <div className="gs-tag-dialog__header">
                    <h4 className="gs-tag-dialog__title">{HEADINGS.DELETE_TAG}</h4>
                </div>

                <div className="gs-tag-dialog__body">
                    <p className="gs-tag-dialog__message">
                        {TAG_TEXT.DELETE_CONFIRMATION(props.selectedTag?.name ?? "")}
                    </p>
                    <p className="gs-tag-dialog__submessage">{TAG_TEXT.DELETE_MESSAGE}</p>
                </div>

                <div className="gs-tag-dialog__footer">
                    <Button
                        type="button"
                        id="delete-tag-btn-modal"
                        className={loadingButtonClass(isLoading, "gs-tag-dialog__submit")}
                        onClick={handleDeleteTag}
                        disabled={isLoading}
                        aria-busy={isLoading || undefined}
                    >
                        <ButtonLoadingContent loading={isLoading} loaderId="delete-tag-btn-modal-loader">
                            {BUTTONS.DELETE}
                        </ButtonLoadingContent>
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
};

export default DeleteTagModal;
